// extracted by mini-css-extract-plugin
export default {"container":"ButtonLabel_container__UhaFY","inactive":"ButtonLabel_inactive__-Y0fE"};